exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.html-content-wrapper[data-v-5cb82284] {\n\tposition: relative;\n}\n.content-iframe[data-v-5cb82284] {\n\twidth: 100%;\n\theight: 100%;\n\tborder: none;\n\tbackground-color: white;\n}\n", ""]);

// exports
